'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
var _date = require('@marmalade/date');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (date) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_ref) {
    var date = _ref.date;
    return 'Please enter a date before ' + (0, _date.dateToString)(date);
  };
  var extraOptions = arguments[2];
  return function (value, values) {
    var valueDate = (0, _date.arrayToDate)(value);
    return (0, _date.getStartOfDay)(date) <= valueDate ? (0, _getErrorMessage2.default)(errorMessage, Object.assign({}, extraOptions, {
      value: valueDate,
      values: values,
      date: (0, _date.getStartOfDay)(date)
    })) : '';
  };
};